<has-client-id-tag>

  <div class="contents">
    
    <div class="empty">
      <p class="empty-message">「EDILENT」のご利用、誠にありがとうございます。<br>
こちらは「EDILENT」でお仕事を受注される編集者・ライター様向けのページとなります。<br>
既にご登録されている（現在ログインをしている）<b>「CROCO ID」</b>は記事制作等を発注するクライアント様として<br>
ご登録がされておりますので、記事制作等のご注文をご検討されている場合は<b><font color="#008000"><a href="https://edilent-client.biz-samurai.com/lp/release.html">「EDILENT for Client」</a></font></b>をご利用ください。</p>
    </div>
  </div>

<script>
  import di from "dependency-injection";
  export default {
    onBeforeMount(props, state) {
    }
  }
</script>
</has-client-id-tag>
